import Page from "./GeoAnalysis";

export default Page;
